import React from "react";

function Footer() {
  return (
    <div className="footer">
      <p>
        Site map | Privacy Policy | Theme park term of use | Copyright /
        Trademark | Oriental Land Co,.Ltd | FnF.com.vn
      </p>
      <p>&copy; FnF. All right Reserved</p>
    </div>
  );
}

export default Footer;
